import { useForm, FieldError } from "react-hook-form";
import { useEffect, useState } from "react";
import { useAxios } from "../../utils/useAxios";
import PageMeta from "../../components/common/PageMeta";
import ContainerBox from "../../plugins/components/container";
import { MyInput } from "../../components/formFields/MyInput";
import ReportPreview from "./components/ReportPreview";
import html2pdf from "html2pdf.js"; // ✅ Import here

import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import { Document, Packer, Paragraph, TextRun } from "docx";

const DriverReports = () => {
  const [sampleReportData, setSampleReportData] = useState<any | null>(null);

  const {
    control,
    handleSubmit,
    register,
    formState: { errors },
    reset,
    setValue,
    watch,
  } = useForm({
    mode: "onSubmit",
  });

  const reportType = watch("reportType"); // Watching the select input

  useEffect(() => {
    setSampleReportData(null);
  }, [reportType]);

  const { res, mutate, isPending, error } = useAxios({
    url: "/api/auth/getReport",
  });

  const onSubmit = (data: any) => {
    mutate(
      {
        formId: "drivers",
        getReport: "driverreports",
        formData: data,
      },
      {
        onSuccess: (res: any) => {
          setSampleReportData(res?.data?.data);
        },
      },
    );
  };

  const handleDownload = () => {
    if (!sampleReportData) return;

    if (reportType === "all") {
      // Export as Excel
      const allRecords = sampleReportData?.data.map((item: any) => {
        const record: any = {};
        item.sections.forEach((section: any) => {
          section.columns.forEach((col: any) => {
            record[col.label] = col.value;
          });
        });
        return record;
      });

      const worksheet = XLSX.utils.json_to_sheet(allRecords);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Driver Reports");
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      saveAs(
        new Blob([excelBuffer], { type: "application/octet-stream" }),
        "drivers_report.xlsx",
      );
    } else if (reportType === "single") {
      const element = document.getElementById("report-content");
      if (!element) return;

      html2pdf()
        .set({
          margin: 0.5,
          filename: "driver_report.pdf",
          image: { type: "jpeg", quality: 0.98 },
          html2canvas: { scale: 2 },
          jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
        })
        .from(element)
        .save();
      // Export as DOCX
      // const paragraphs: Paragraph[] = [];

      // sampleReportData?.data[0]?.sections.forEach((section: any) => {
      //   paragraphs.push(new Paragraph({ text: section.title }));
      //   section.columns.forEach((col: any) => {
      //     paragraphs.push(
      //       new Paragraph({
      //         children: [
      //           new TextRun({ text: `${col.label}: `, bold: true }),
      //           new TextRun(`${col.value}`),
      //         ],
      //       }),
      //     );
      //   });
      //   paragraphs.push(new Paragraph("")); // spacing
      // });

      // const doc = new Document({
      //   sections: [{ properties: {}, children: paragraphs }],
      // });

      // Packer.toBlob(doc).then((blob) => {
      //   saveAs(blob, "driver_report.docx");
      // });
    }
  };

  // const handleDownloadPDF = () => {
  //   const element = document.getElementById("report-content");
  //   if (!element) return;

  //   html2pdf()
  //     .set({
  //       margin: 0.5,
  //       filename: "driver_report.pdf",
  //       image: { type: "jpeg", quality: 0.98 },
  //       html2canvas: { scale: 2 },
  //       jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
  //     })
  //     .from(element)
  //     .save();
  // };

  return (
    <>
      <PageMeta title="TTM Add Drivers | Admin Drivers" description="" />
      <div className="mb-3">
        <ContainerBox title={"Fill Details to get report"} actions={<></>}>
          <form className="space-y-4" onSubmit={handleSubmit(onSubmit)}>
            <div className={`grid grid-cols-2 gap-4`}>
              <div>
                <select
                  {...register("reportType")}
                  className="h-9 w-full border px-4 py-1 text-sm shadow-theme-xs placeholder:text-gray-400 focus:outline-none focus:ring bg-transparent text-gray-800 border-gray-300 focus:border-brand-300 focus:ring focus:ring-brand-500/10"
                >
                  <option value="all">All Drivers Reports</option>
                  <option value="single">Single Driver Reports</option>
                </select>
              </div>
              {reportType === "single" && (
                <div>
                  {/* <MyInput
                    name="email"
                    register={register}
                    error={errors["email"] as FieldError | undefined}
                    placeholder="Enter Email address"
                    type="text"
                  /> */}
                </div>
              )}
            </div>
            <div className="flex border-t pt-3 justify-start gap-2">
              <button
                type="reset"
                className="rounded bg-gray-200 px-6 py-2 text-black font-medium hover:bg-gray-300"
                onClick={() => reset()}
              >
                Reset
              </button>
              <button
                type="submit"
                className="rounded bg-indigo-500 px-6 py-2 text-white font-medium hover:bg-indigo-700"
              >
                {isPending ? "Submitting" : "Submit"}
              </button>
            </div>
          </form>
        </ContainerBox>
      </div>
      <div>
        {sampleReportData && (
          <ContainerBox
            title={"Report"}
            actions={
              <>
                <button
                  className="rounded bg-green-600 px-6 py-2 text-white font-medium hover:bg-gray-300"
                  onClick={handleDownload}
                >
                  {reportType === "all" ? "Download Excel" : "Download PDF"}
                </button>
              </>
            }
          >
            <div id="report-content">
              <ReportPreview name="Driver" reportData={sampleReportData} />
            </div>
          </ContainerBox>
        )}
      </div>
    </>
  );
};

export default DriverReports;
